import api from "@/apis/UserSettingAPI";

export default {
  /**
   * Load danh sách bao cáo
   */
  async set(context, payload) {
    context.commit("updateLoading", true);

    //request
    var res = await api.set(payload);

    context.commit("updateLoading", false);

    if (res) {
      context.commit("updateItem", res);
    }

    return res;
  },
};
